import React from 'react';

import './XFormSubmissions.scss';
import { formatDateNl } from '../../../helpers/date';

export default function XFormSubmissions({ submissions = [] }) {
  return (
    <div className="xformSubmissions">
      <div className="xformSubmissions-header">
        <h2 className="xformSubmissions-header-title">Mijn inzendingen</h2>
      </div>

      {submissions.length === 0 ? (
        <p className="xformSubmissions-empty">
          Geen inzendingen gevonden.
        </p>
      ) : (
        <ul className="xformSubmissions-list">
          {submissions.map((item) => (
            <li key={item.xuid} className="xformSubmissions-list-item">
              <a
                href={`/xform-answers/${item.xuid}?returnTo=/xform-submissions`}
                className="xformSubmissions-link"
              >
                <div className="xformSubmissions-list-item-content">
                  <div>
                    <p className="xformSubmissions-list-item-title">
                      {item.formName || '—'}
                    </p>

                    {item.createdBy && (
                      <span className="xformSubmissions-list-item-subtitle">
                        {item.createdBy}
                      </span>
                    )}
                  </div>

                  {item.updatedAt && (
                    <div className="nowrap">
                      <span className="xformSubmissions-list-item-date">
                        {formatDateNl(item.updatedAt)}
                      </span>
                    </div>
                  )}
                </div>
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
